export enum PromotionStatusEnum {
  DRAFT = 'DRAFT',
  PENDING = 'PENDING',
  STARTED = 'STARTED',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  CLOSED = 'CLOSED',
}
